"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 港股合规
 */
var user_1 = __importDefault(require("../user"));
var thisuser = user_1.default.get();
exports.default = {
    /**
     * 是否需要延迟数据
     */
    isDelay: function () {
        return __awaiter(this, void 0, void 0, function () {
            var back;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, $.ajax({
                            url: '//push2.eastmoney.com/api/qt/stock/get?cb=?',
                            type: 'GET',
                            dataType: 'jsonp',
                            data: {
                                ut: 'bd1d9ddb04089700cf9c27f6f7426281'
                            }
                        })];
                    case 1:
                        back = _a.sent();
                        if (back.lt == 2) { //非大陆用户
                            return [2 /*return*/, {
                                    re: true,
                                    message: "\u975E\u4E2D\u56FD\u5927\u9646\u7528\u6237\u4EC5\u53EF\u67E5\u770B\u6E2F\u80A1\u5EF6\u65F615\u5206\u949F\u884C\u60C5"
                                }];
                        }
                        if (thisuser == null) { //未登录
                            return [2 /*return*/, {
                                    re: true,
                                    message: "\u672A\u767B\u5F55\u7528\u6237\u4EC5\u53EF\u67E5\u770B\u6E2F\u80A1\u5EF6\u65F615\u5206\u949F\u884C\u60C5\uFF0C<a href=\"https://passport2.eastmoney.com/pub/login?backurl=".concat(encodeURIComponent(self.location.href), "\" class=\"normal\">\u53BB\u767B\u5F55</a>")
                                }];
                        }
                        return [2 /*return*/, {
                                re: false,
                                message: ''
                            }];
                }
            });
        });
    },
    isdelaycache: null,
    /**
     * 是否需要延迟数据带缓存
     */
    isDelayCache: function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isdelaycache != null) {
                            return [2 /*return*/, this.isdelaycache];
                        }
                        return [4 /*yield*/, this.isDelay()];
                    case 1:
                        result = _a.sent();
                        this.isdelaycache = result;
                        return [2 /*return*/, result];
                }
            });
        });
    }
};
